import { getFullName, Name } from "@/utils/names";

// This is defined separately from the patientName filter in case patient names and user names need to be formatted
// differently
export function formatUserName(value?: Name) {
  if (value) {
    return getFullName(value);
  }
}
